import {
  Box,
  Center,
  ListItem,
  Text,
  UnorderedList,
  Flex,
} from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../i18n';
import {
  Icon,
  IconConsumerFilled,
  IconIncomeFilled,
  IconUnderwritingFilled,
} from 'wg-fe-ui';
import { FlowsQuestion } from '../../../types/FlowsTypes';
import LoadingSpinner from '../../../../../common/src/components/LoadingSpinner';

interface Props {
  groupId: string;
  tag: string;
  questions: FlowsQuestion[];
  onClick: () => void;
  isLoading?: boolean;
}

const QuestionBox: React.FC<React.PropsWithChildren<Props>> = ({
  groupId,
  tag,
  questions,
  onClick,
  isLoading,
}) => {
  const getIcon = (type: string) => {
    switch (type?.toLowerCase()) {
      case 'policy_holder':
        return <IconConsumerFilled />;
      case 'specs':
        return <IconIncomeFilled />;
      case 'risk_analysis':
        return <IconUnderwritingFilled />;
      default:
        return <Icon type={tag?.toLowerCase()} />;
    }
  };

  return (
    <Box
      border="1px"
      borderColor="gray.50"
      boxShadow="level3"
      onClick={onClick}
      _hover={{ cursor: 'pointer', backgroundColor: 'gray.ultraLight' }}
      borderRadius="md"
      p="4"
      m="4"
      position="relative"
    >
      {isLoading && (
        <Center
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          backdropFilter="blur(10px)"
        >
          <LoadingSpinner />
        </Center>
      )}
      <Flex alignItems="center">
        <Box mr="4">{getIcon(tag)}</Box>
        <Text textStyle="normalBodyBold" wordBreak="break-all">
          Group id: {groupId}
        </Text>
      </Flex>
      <Text textStyle="normalBody">Questions:</Text>
      <UnorderedList>
        {questions.map(({ id, title }) => {
          return (
            <Box key={`question_${id}`}>
              <ListItem>
                {handleResponseLanguage(title) ? (
                  <Text textStyle="smallBody">
                    {handleResponseLanguage(title)}
                  </Text>
                ) : (
                  <Text textStyle="smallBodyItalic">No title given</Text>
                )}
              </ListItem>
            </Box>
          );
        })}
      </UnorderedList>
    </Box>
  );
};

export default QuestionBox;
